import { buildNum } from "../utils/format";

export default {
    price: buildNum(50, 'K'),
    hasCustomNavbar: true,
    hasCustomBackground: true,
    hasAnimations: true
}
